if (window.__psflex_platform_type === undefined) {
    window.__psflex_platform_type = 'web'
}

window.__psflex_version = '0.4.2'
window.__base_url = 'https://psflex.forjota.com.ar/downloads/'

window.__downloads = [
    {
        key: 'windows',
        label: 'Para Windows v' + window.__psflex_version,
        platform: 'windows',
        link: window.__base_url + window.__psflex_version + '/psflex-' + window.__psflex_version + '.exe'
    },
    {
        key: 'linux_amd64',
        label: 'Para Linux (amd64) v' + window.__psflex_version,
        platform: 'linux',
        link: window.__base_url + window.__psflex_version + '/psflex-' + window.__psflex_version + '_amd64.deb'
    },
    {
        key: 'linux_i386',
        label: 'Para Linux (i386) v' + window.__psflex_version,
        platform: 'linux',
        link: window.__base_url + window.__psflex_version + '/psflex-' + window.__psflex_version + '_i386.deb'
    }
]



// WEBPACK FOOTER //
// ./src/configs.js